module.exports = require("./hi-IN");